export const MAPBOX_TOKEN = process.env.MIX_MAPBOX_TOKEN || '';

// The variance in when the function on the scroll listener will fire
export const SCROLL_DEBOUNCE = 100;
// The variance in when the function on the resize listener will fire
export const RESIZE_DEBOUNCE = 100;

// use for screenCategory() in library.js
export const SCREEN_SIZES = {
  mobile: {
    title: 'mobile',
    width: 320,
  },
  tablet: {
    title: 'tablet',
    width: 680,
  },
  desktop: {
    title: 'desktop',
    width: 1100,
  },
};

export const EVENT_LITERATURE_CART_UPDATE_ITEMS = 'EVENT_LITERATURE_CART_UPDATE_ITEMS';
export const EVENT_LITERATURE_PLACE_REQUEST = 'EVENT_LITERATURE_PLACE_REQUEST';
export const EVENT_LITERATURE_CART_REMOVE_ITEM = 'EVENT_LITERATURE_CART_REMOVE_ITEM';
export const EVENT_LITERATURE_CART_FOCUS_ITEM = 'EVENT_LITERATURE_CART_FOCUS_ITEM';
